export const LOGIN_SUCCESS =
  'You have received an email which contains the authorization login code.'
export const LOGOUT_SUCCESS = 'User has been successfully logged out.'
export const GENERIC_ERROR = 'Something went wrong!'
export const ORDER_UPDATE = 'Order has been updated successfully!'
